const ns = 'BZ-DesignSystem';

export const apiClasses = {
    dropdown: `${ns}-Dropdown`,
    dropdownButton: `${ns}-Dropdown-Button`,
    dropdownContent: `${ns}-Dropdown-Content`,
};
